"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _appearWrapper = require("../../animations/appearWrapper");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Loader = _styledComponents.default.div`
  ${({
  color,
  size,
  speed,
  theme
}) => (0, _styledComponents.css)`
    border:
      calc(0.12 * ${size}px)
      solid
      ${color && theme.colors[color]};
    border-top:
      calc(0.12 * ${size}px)
      solid
      transparent;
    border-radius: 50%;
    width: ${size}px;
    height: ${size}px;
    animation: ${_appearWrapper.spin360} calc((100/${speed}) * 0.1s) linear infinite;
  `}
`;
exports.Loader = Loader;